<form [formGroup]="form" class="c-form__body">
  <ng-container *ngIf="!isEmailConfirm">
    <div class="c-form__header">
      <div class="c-form__title c-form__title--dark">Forgot your password?</div>
    </div>

    <div class="c-form__row">
      <div class="c-form__text c-form__text--dark c-form__text--center">
        Enter the email address and we’ll send you next instructions to reset your password.
      </div>
    </div>

    <div class="c-form__row">
      <gtd-form-field-email
        [control]="email"
        label="Email"
        placeholder="Enter your email"
        [cssClass]="{ 'is-error': email.invalid && email.touched }"
        [errorText]="email.invalid && email.touched ? errorTextBuilder(email) : ''"
      ></gtd-form-field-email>
    </div>

    <div class="c-form__row c-form__row--submit">
      <button type="button" class="c-button c-button--primary -large -full" [class.is-disabled]="email.invalid" (click)="confirmEmail()">
        Reset Password
        <span class="c-button__icon icon-arrow-1"></span>
      </button>
    </div>

    <div class="c-form__row c-form__footer">
      <a class="c-form__footer-link c-form__footer-link--back" (click)="backToAuthPage()">
        <span class="c-button__icon icon-arrow-1 --rotate"></span>
        Return Back
      </a>
      <!-- <a class="c-form__footer-link" routerLink="/auth/wizard">Create new account</a> -->
      <p class="c-form__footer-full-row">
        Support:&nbsp;<a class="c-form__footer-link--blue" href="mailto:support@irev.com" target="_blank">support&#64;irev.com</a>
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isEmailConfirm && !isPasswordChanged">
    <div class="c-form__header">
      <div class="c-form__title c-form__title--dark">Restore password</div>
    </div>

    <div class="c-form__row">
      <div class="c-form__text c-form__text--center">
        This page is protected by Two-factor authentication: We sent code to your email
        <span class="c-form__text--dark">{{ email.value }}</span>
      </div>
    </div>

    <div class="c-form__row">
      <gtd-form-field-confirm-code formControlName="code"></gtd-form-field-confirm-code>
    </div>

    <div class="c-form__row">
      <gtd-form-field-password
        [control]="password"
        placeholder="Password"
        [cssClass]="{ 'is-error': password.invalid && password.touched }"
        [errorText]="password.invalid && password.touched ? errorTextBuilder(password) : ''"
      ></gtd-form-field-password>
    </div>

    <div class="c-form__row">
      <gtd-form-field-password
        [control]="passwordConfirm"
        placeholder="Confirm Password"
        [cssClass]="{ 'is-error': passwordConfirm.value !== password.value || (passwordConfirm.invalid && passwordConfirm.touched) }"
        [errorText]="
          passwordConfirm.value !== password.value || (passwordConfirm.invalid && passwordConfirm.touched)
            ? errorTextBuilder(passwordConfirm)
            : ''
        "
      ></gtd-form-field-password>
    </div>

    <div class="c-form__row c-form__row--submit">
      <button
        type="button"
        class="c-button c-button--primary -large -full"
        [class.is-disabled]="form.invalid || passwordConfirm.value !== password.value"
        (click)="resetPassword()"
      >
        Reset Password
        <span class="c-button__icon icon-arrow-1"></span>
      </button>
    </div>

    <div class="c-form__row c-form__footer">
      <a class="c-form__footer-link c-form__footer-link--back" (click)="backToEmail()">
        <span class="c-button__icon icon-arrow-1 --rotate"></span>
        Return Back
      </a>
      <p class="c-form__footer-full-row">
        Support:&nbsp;<a class="c-form__footer-link--blue" href="mailto:support@irev.com" target="_blank">support&#64;irev.com</a>
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isPasswordChanged && isEmailConfirm">
    <div class="c-form__header">
      <div class="c-form__title c-form__title--dark">Forgot your password?</div>
    </div>

    <div class="c-form__row">
      <div class="c-form__text--green-bg c-form__text--center">Your password was changed. Now you can sign in.</div>
    </div>

    <div class="c-form__row c-form__row--submit">
      <button type="button" class="c-button c-button--primary -large -full" (click)="backToAuthPage()">
        Sign In
        <span class="c-button__icon icon-arrow-1"></span>
      </button>
    </div>

    <div class="c-form__footer --center">
      Support:&nbsp;<a class="c-form__footer-link--blue" href="mailto:support@irev.com" target="_blank">support&#64;irev.com</a>
    </div>
  </ng-container>
</form>
